var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (t) {
buf.push("<div id=\"import-google\" class=\"content-block\"><div class=\"content-illustration google-services\"></div><h2>" + (jade.escape(null == (jade_interp = t('import google account')) ? "" : jade_interp)) + "</h2><p>" + (jade.escape(null == (jade_interp = t('import google account tip')) ? "" : jade_interp)) + "</p><a id=\"import-google\" type=\"button\" href=\"/register?step=import_google\" class=\"btn btn-primary\">" + (jade.escape(null == (jade_interp = t('import from google')) ? "" : jade_interp)) + "</a></div>");}.call(this,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_register_import.jade
 ** module id = 71
 ** module chunks = 0
 **/